import { useCallback } from 'react';

export const useAccessibleClick = (callback, { preventDefault = true } = {}) => {
    return useCallback(
        (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                if (preventDefault) {
                    e.preventDefault();
                }
                callback();
            }
        },
        [callback, preventDefault]
    );
};
